module.exports = __webpack_public_path__ + "wxMicroService/img/boss.2ff884c3.png";